// extracted by mini-css-extract-plugin
export var attachment = "_lt-a";
export var emailContainer = "_lt-4";
export var emailContentPaddedContainer = "_lt-b";
export var emailHeader = "_lt-6";
export var emailIframe = "_lt-3";
export var emailInfoIcon = "_lt-9";
export var emailShortenedSummary = "_lt-e";
export var infoDropdown = "_lt-0";
export var infoRowBoundedContent = "_lt-d";
export var internal = "_lt-5";
export var merchant = "_lt-8";
export var messageInputContainer = "_lt-h";
export var normal = "_lt-7";
export var replyCard = "_lt-f";
export var subtleButton = "_lt-1";
export var subtleButtonIconContainer = "_lt-2";
export var toggleViewRepliesButton = "_lt-c";
export var wrappingText = "_lt-g";